/**
 * Single source of truth for tax-related label terminology, driven by the
 * company's `taxLabel` setting.
 *
 * Pakistan default (taxLabel = 'GST'):
 *   - "NTN" (National Tax Number)
 *   - "STN" / "STRN" (Sales Tax Number / Registration Number)
 *   - "GST" (General Sales Tax)
 *
 * GCC / VAT mode (taxLabel = 'VAT'):
 *   - "CR" (Commercial Registration) replaces NTN
 *   - "VAT Number" replaces STN / Sales Tax Number
 *   - "VAT" replaces GST
 *
 * Data field names on Firestore (ntn, gstNo, strn) remain unchanged — only
 * the LABELS shown in the UI and printed documents switch. This avoids any
 * data migration when a company toggles to VAT mode.
 */

export const getTaxTerms = (activeCompany) => {
  const label = (activeCompany?.taxLabel || 'GST').toUpperCase();
  const isVat = label === 'VAT';
  if (isVat) {
    return {
      taxLabel: 'VAT',
      taxLabelFull: 'Value Added Tax',
      registrationLabel: 'CR',
      registrationLabelFull: 'Commercial Registration',
      taxNumberLabel: 'VAT Number',
      taxNumberShort: 'VAT #',
      isVat: true
    };
  }
  return {
    taxLabel: 'GST',
    taxLabelFull: 'General Sales Tax',
    registrationLabel: 'NTN',
    registrationLabelFull: 'National Tax Number',
    taxNumberLabel: 'STN',
    taxNumberShort: 'STN',
    isVat: false
  };
};

export default getTaxTerms;
